<!--赖传峰-->
<!--2023/2/28-->
<template>
  <div
    v-if="isIOS"
    :key="key"
    class="mobile-install-box"
  >
    <a
      :href="appInstallLinks.appStore"
      :style="{ backgroundImage: `url(${appStore})` }"
      class="icon-box ios"
    />
  </div>
  <div
    v-if="isAndroid"
    :key="key"
    class="mobile-install-box"
  >
    <a
      :href="appInstallLinks.googlePlay"
      :style="{ backgroundImage: `url(${googlePlay})` }"
      class="icon-box android-google-play"
    />
    <a
      v-if="!isPikPakClient()"
      :href="appInstallLinks.androidApk"
      :style="{ backgroundImage: `url(${androidApk})` }"
      class="icon-box android"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  nextTick,
  onMounted,
  reactive,
  ref,
} from '#imports'
import { isPikPakClient } from '@/utils'
import {
  appInstallLink,
  osNameInServerAndClient,
  useAppInstallIcon,
} from '~/composables/useInstallChannels'
import {
  AppInstallPlatform,
  OSName,
} from '~/types/enum'

const { googlePlay, androidApk, appStore } = useAppInstallIcon()

const generateInstallLinks = () => ({
  appStore: appInstallLink(AppInstallPlatform.APPLE_STORE),
  googlePlay: appInstallLink(AppInstallPlatform.GOOGLE_PLAY),
  androidApk: appInstallLink(AppInstallPlatform.ANDROID_APK),
})

const isAndroid = osNameInServerAndClient() === OSName.ANDROID
const isIOS = osNameInServerAndClient() === OSName.IOS
const appInstallLinks = reactive(generateInstallLinks())
const key = ref(Date.now())

/**
 * 为什么需要再执行一次呢？因为服务端没有 localStorage，所以客户端需要读取 localStorage 重新渲染一次
 * 通过修改 key 的试，强制重新渲染
 */
onMounted(async () => {
  await nextTick()
  key.value = Date.now()
})

</script>

<style
  lang="less"
  scoped
>
.mobile-install-box {
  margin-top: 16px;

  .icon-box {
    display: inline-block;
    width: 189px;
    height: 54px;
    background-size: 100% 100%;

    &.ios {
      margin-bottom: 52px;
    }

    &.android {
      margin-top: 8px;
    }
  }
}
</style>
